/**
 * WO-D2.M — account section layout (now an Account TAB).
 *
 * Nested native <Stack> (expo-router) living inside the (tabs) group. Shares the
 * brand header options from the parent (app) stack. The (tabs) layout renders
 * this whole `account` segment as a tab screen with `headerShown: false`, so
 * this stack owns all account headers (no double bar).
 *
 * `index` is this stack's root — it is the Account tab's landing screen. There
 * is no longer a "‹ Home" back affordance: the persistent bottom tab bar is the
 * top-level navigation, so the user returns to other sections by tapping a tab.
 * `users` / `comms` / `billing` are pushed within this stack and get the normal
 * native back button automatically. Because this nested stack lives inside the
 * tabs group, the tab bar stays visible while drilling into these sub-screens.
 */
import { Stack } from 'expo-router';
import { stackScreenOptions } from '../../_layout';

export default function AccountLayout() {
  return (
    <Stack screenOptions={stackScreenOptions}>
      <Stack.Screen name="index" options={{ title: 'Account & Settings' }} />
      <Stack.Screen name="trades" options={{ title: 'Your trades' }} />
      <Stack.Screen name="users" options={{ title: 'Users' }} />
      <Stack.Screen name="team" options={{ title: 'Team' }} />
      <Stack.Screen name="comms" options={{ title: 'Communications' }} />
      <Stack.Screen name="billing" options={{ title: 'Billing' }} />
      <Stack.Screen name="payments" options={{ title: 'Payments' }} />
      <Stack.Screen name="branding" options={{ title: 'Branding' }} />
      <Stack.Screen name="security" options={{ title: 'Sessions & security' }} />
      <Stack.Screen name="change-password" options={{ title: 'Change password' }} />
      <Stack.Screen name="delete-account" options={{ title: 'Delete account' }} />
    </Stack>
  );
}
